import React from "react";

export default function LoveLetter() {
  return (
    <section id="lettre" data-testid="loveletter-section" className="px-6 md:px-12 lg:px-24 py-24 lg:py-32 relative">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <p className="font-accent text-3xl text-rose-300">une lettre</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-rose-50 mt-2">Amor,</h2>
        </div>

        <div className="romantic-card rounded-2xl p-10 md:p-14 relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-rose-700/10 blur-2xl" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full bg-rose-900/30 blur-2xl" />

          <p className="font-accent text-3xl md:text-4xl text-rose-100 leading-loose">
            Depuis le jour où nos chemins se sont croisés, ma vie a pris une nouvelle couleur — celle de tes yeux,
            celle de ton sourire, celle de nos rires partagés.
          </p>
          <p className="font-accent text-3xl md:text-4xl text-rose-200/90 leading-loose mt-8">
            Chaque seconde compte. Chaque souvenir, je le garde précieusement, comme un trésor.
          </p>
          <p className="font-accent text-3xl md:text-4xl text-rose-300 leading-loose mt-8">
            Et le 22 juin, à 15h, sera encore un de ces moments qu'on n'oubliera jamais.
          </p>

          <div className="cursive-divider mt-12">
            <span className="font-accent text-2xl">♡</span>
          </div>

          <p className="font-accent text-2xl text-rose-200/80 mt-8 text-right">— À toi, pour toujours.</p>
        </div>
      </div>
    </section>
  );
}
